import { render, staticRenderFns } from "./ApiButton.vue?vue&type=template&id=7b8a4b06&"
import script from "./ApiButton.vue?vue&type=script&lang=ts&"
export * from "./ApiButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports